import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Save } from 'lucide-react';

const ContactTab = ({ contactInfo, setContactInfo, saving, onSave }) => {
  return (
    <div className="bg-zinc-900 rounded-lg border border-zinc-800 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-white">Contact Information</h2>
        <Button onClick={onSave} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label className="text-zinc-300">Email</Label>
          <Input
            value={contactInfo.email || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-zinc-300">Phone</Label>
          <Input
            value={contactInfo.phone || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, phone: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-zinc-300">Address</Label>
          <Input
            value={contactInfo.address || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, address: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-zinc-300">Working Hours</Label>
          <Input
            value={contactInfo.working_hours || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, working_hours: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactTab;
